import { render, staticRenderFns } from "./SubDashboardContainer.vue?vue&type=template&id=ecf06d40&"
import script from "./SubDashboardContainer.vue?vue&type=script&lang=ts&"
export * from "./SubDashboardContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports